import React from 'react';
import { Box } from '@mui/material';
import EvaluationCard from './EvaluationCard';

const EvaluationsSection = ({ application }) => {
  if (!application) return null;

  return (
    <Box>
      {/* Application Evaluation */}
      {application.ranking_data && (
        <EvaluationCard
          data={application.ranking_data}
          title="Application Evaluation"
          gradeLabel="Overall Grade"
          scoreLabel="Based on job requirements"
        />
      )}

      {/* Resume Evaluation */}
      {application.profile_ranking && (
        <EvaluationCard
          data={application.profile_ranking}
          title="Resume Evaluation"
          gradeLabel="Profile Grade"
          scoreLabel="Overall resume quality"
        />
      )}
    </Box>
  );
};

export default EvaluationsSection;